var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNote({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-inline--fa fa-fw",
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1667 11.6667V6.33333C17.1667 4.67647 15.8236 3.33333 14.1667 3.33333H6.83337C5.17652 3.33333 3.83337 4.67647 3.83337 6.33333V13.6667C3.83337 15.3235 5.17652 16.6667 6.83337 16.6667H11.75M17.1667 11.6667L11.75 16.6667M17.1667 11.6667H13.75C12.6455 11.6667 11.75 12.5621 11.75 13.6667V16.6667",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16663 6.66667H13.8333",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16663 10H10.5",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default "data:image/svg+xml;base64,PHN2ZyBjbGFzc05hbWU9InN2Zy1pbmxpbmUtLWZhIGZhLWZ3IiB2aWV3Qm94PSIwIDAgMjEgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xNy4xNjY3IDExLjY2NjdWNi4zMzMzM0MxNy4xNjY3IDQuNjc2NDcgMTUuODIzNiAzLjMzMzMzIDE0LjE2NjcgMy4zMzMzM0g2LjgzMzM3QzUuMTc2NTIgMy4zMzMzMyAzLjgzMzM3IDQuNjc2NDcgMy44MzMzNyA2LjMzMzMzVjEzLjY2NjdDMy44MzMzNyAxNS4zMjM1IDUuMTc2NTIgMTYuNjY2NyA2LjgzMzM3IDE2LjY2NjdIMTEuNzVNMTcuMTY2NyAxMS42NjY3TDExLjc1IDE2LjY2NjdNMTcuMTY2NyAxMS42NjY3SDEzLjc1QzEyLjY0NTUgMTEuNjY2NyAxMS43NSAxMi41NjIxIDExLjc1IDEzLjY2NjdWMTYuNjY2NyIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1vcGFjaXR5PSIwLjciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNy4xNjY2MyA2LjY2NjY3SDEzLjgzMzMiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utb3BhY2l0eT0iMC43IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTcuMTY2NjMgMTBIMTAuNSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1vcGFjaXR5PSIwLjciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };